import { PlaidProducts } from '@/types/plaid.types'

export const ADD_ACCOUNT_ITEMS = [
  {
    label: 'Checking',
    param: `${PlaidProducts.Transactions}, checking`,
  },
  {
    label: 'Savings',
    param: `${PlaidProducts.Transactions}, savings`,
  },
  {
    label: 'Credit Cards',
    param: `${PlaidProducts.Transactions}, credit_cards`,
  },
  {
    label: 'Retirement',
    param: `${PlaidProducts.Investments}, retairement`,
  },
  {
    label: 'Investments',
    param: `${PlaidProducts.Investments}, investments`,
  },
  {
    label: 'Debt',
    param: `${PlaidProducts.Liabilities}, debt`,
  },
  {
    label: 'Manual',
    param: 'manual',
  },
  {
    label: 'Other',
    param: `${PlaidProducts.Transactions}, other`,
  },
]
